let _storage: Storage | null = null;
let _isLocalAvailabile = false;
let _isSessionAvailabile = false;

class ObjectStorage implements Storage {
  constructor() {
    this.obj = {};
  }

  public length = 0;
  protected obj: Record<string, string>;

  key(): string | null {
    throw new Error("Method not implemented.");
  }

  getItem(key: string) {
    if (this.obj[key] !== undefined && this.obj[key] !== null) {
      return this.obj[key];
    }

    return null;
  }

  setItem(key: string, value: string) {
    this.obj[key] = value;
  }

  clear() {
    this.obj = {};
  }

  removeItem(key: string) {
    if (this.obj[key] !== undefined) {
      delete this.obj[key];
    }
  }
}

function initStorage(storageType: string) {
  if (!_storage) {
    if (typeof window === "undefined") {
      _storage = new ObjectStorage();
    } else {
      try {
        const key = "__ls_test__";
        const value = "test";
        localStorage.setItem(key, value);
        const result = localStorage.getItem(key);
        if (result === value) {
          _storage = localStorage;
          _isLocalAvailabile = true;
          localStorage.removeItem(key);
        }
      } catch(e) {
        // do nothing
      }

      try {
        const key = "__ss_test__";
        const value = "test";
        sessionStorage.setItem(key, value);
        const result = sessionStorage.getItem(key);
        if (result === value) {
          if (!_storage) {
            _storage = sessionStorage;
          }
          _isSessionAvailabile = true;
          sessionStorage.removeItem(key);
        }
      } catch(e) {
        // do nothing
      }

      if (!_storage) {
        _storage = new ObjectStorage();
      }
    }
  }

  if (storageType === "localStorage" && _isLocalAvailabile) {
    return localStorage;
  }

  if (storageType === "sessionStorage" && _isSessionAvailabile) {
    return sessionStorage;
  }

  return _storage;
}

const DEFAULT_STORAGE_TYPE = "localStorage";

const StorageService = {
  getItem: (key: string, storageType = DEFAULT_STORAGE_TYPE) => {
    const storage = initStorage(storageType);
    return storage.getItem(key);
  },
  setItem: (key: string, value: string, storageType = DEFAULT_STORAGE_TYPE) => {
    const storage = initStorage(storageType);
    storage.setItem(key, value);
  },
  removeItem: (key: string, storageType = DEFAULT_STORAGE_TYPE) => {
    const storage = initStorage(storageType);
    storage.removeItem(key);
  },
  clear: (storageType = DEFAULT_STORAGE_TYPE) => {
    const storage = initStorage(storageType);
    storage.clear();
  },
  localStorage:
    initStorage(DEFAULT_STORAGE_TYPE) && _isLocalAvailabile
      ? localStorage
      : _storage,
  sessionStorage:
    initStorage(DEFAULT_STORAGE_TYPE) && _isSessionAvailabile
      ? sessionStorage
      : _storage,
};

export default StorageService;
